import React from 'react';
import { Star, Mail, Phone, MapPin, ArrowUp } from 'lucide-react';
import { Button } from './ui/button';
import { Link } from 'react-router-dom';

export const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const services = [
    { name: 'Celebrity Management', id: 'celebrity' },
    { name: 'Event Management', id: 'events' },
    { name: 'Sponsorship Management', id: 'sponsorship' },
    { name: 'Merchandising & Gifting', id: 'merchandising' },
    { name: 'Sporting Experiences', id: 'sports' }
  ];

  return (
    <footer className="bg-gray-900 text-white relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-r from-amber-400/5 to-orange-500/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-gradient-to-r from-purple-400/5 to-pink-500/5 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10">
        {/* Main Footer Content */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">

            {/* Company Info */}
            <div className="space-y-6">
              <div className="cursor-pointer" onClick={scrollToTop}>
                <img
                  src="/logo.png"
                  alt="Centre Stage Sports & Celebrities Logo"
                  className="w-40 h-auto object-contain hover:scale-105 transition-transform duration-300"
                />
              </div>

              <p className="text-gray-400 leading-relaxed">
                Got a big idea? Let's talk about it. We respond within 24 hours.
              </p>


            </div>

            {/* Services */}
            <div className="space-y-6">
              <h4 className="text-lg font-semibold">Our Services</h4>
              <ul className="space-y-3">
                {services.map((service) => (
                  <li key={service.id}>
                    <button
                      onClick={() => scrollToSection(service.id)}
                      className="text-gray-400 hover:text-amber-400 transition-colors duration-300 text-left"
                    >
                      {service.name}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Quick Links */}
            <div className="space-y-6">
              <h4 className="text-lg font-semibold">Quick Links</h4>
              <div className="flex flex-col gap-3">
                <button
                  onClick={() => scrollToSection('hero')}
                  className="text-gray-400 hover:text-amber-400 transition-colors duration-300 text-left w-full"
                >
                  Home
                </button>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-400 hover:text-amber-400 transition-colors duration-300 text-left w-full"
                >
                  About Us
                </button>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-400 hover:text-amber-400 transition-colors duration-300 text-left w-full"
                >
                  Contact
                </button>
                <button
                  onClick={() => window.location.href = '/privacy'}
                  className="text-gray-400 hover:text-amber-400 transition-colors duration-300 text-left w-full"
                >
                  Privacy Policy
                </button>
                <button
                  onClick={() => window.location.href = '/terms'}
                  className="text-gray-400 hover:text-amber-400 transition-colors duration-300 text-left w-full"
                >
                  Terms of Service
                </button>
              </div>
            </div>

            {/* Contact Info */}
            <div className="space-y-6">
              <h4 className="text-lg font-semibold">Contact Us</h4>
              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <Mail className="w-5 h-5 text-amber-400 icon-outline" />
                  <p className="text-gray-400">
                    connect@centrestageent.com
                  </p>
                </div>
                <div className="flex items-center gap-3">
                  <Phone className="w-5 h-5 text-amber-400 icon-outline" />
                  <p className="text-gray-400">+91 98201 72766</p>
                </div>
                <div className="flex items-center gap-3">
                  <MapPin className="w-5 h-5 text-amber-400 icon-outline" />
                  <p className="text-gray-400">
                    101 Saroj Building, VP Road<br />
                    Vile Parle, Mumbai 56
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <div className="text-gray-400 text-sm">
                © 2026 Centre Stage Sports & Celebrities. All rights reserved.
              </div>

              <div className="flex items-center gap-6">
                <span className="text-gray-400 text-sm">Made with ❤️</span>
                <Button
                  onClick={scrollToTop}
                  variant="ghost"
                  size="sm"
                  className="text-gray-400 hover:text-amber-400 p-2"
                >
                  <ArrowUp className="w-5 h-5 icon-outline" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};